import utils from '../../Utils';
import { useState, useEffect } from 'react';
import apiClient from '../../apis/ApiInterceptor';
import { openNotification } from '../notifications';
import Features from '../../enums/features';

const UserBasicInformation = ({ user }) => {
    const [follower, setFollower] = useState(null);
    const [isUsersBasicInfoFeature, setIsUsersBasicInfoFeature] = useState(false);

    useEffect(() => {
        const features = JSON.parse(localStorage.getItem('user_features') || '{}');
        const usersBasicInfoFeature = features[Features.USERS_BASIC_INFO] || false;
        setIsUsersBasicInfoFeature(usersBasicInfoFeature);
    }, []);

    useEffect(() => {
        const fetchAssigned = async () => {
            try {
                if(user && user.assigned_id){
                    const response = await apiClient.get(`/users/${user.assigned_id}`);
                    if (response.status !== 200) {
                        openNotification(
                        'error',
                        'Error al cargar la persona a la que está asignado el usuario'
                        );
                        setFollower(null)
                        return;
                    }
                    setFollower(response.data)
                }
            } catch (err) {
                setFollower(null)
            }
        };
        fetchAssigned();
    }, [user]);

    if (!isUsersBasicInfoFeature){
        return null;
    }

    if (!user){
        return null
    }

    return (
    <>
        {user.birthdate &&
            <div>
            <p><span>{`${utils.calculateAge(user.birthdate)} años`}</span></p>
            <p><span>Cumpleaños:</span></p>
            <p><span>{utils.formatDayMonth(user.birthdate)}</span></p>
            </div>
        }
        {user.phone &&
            <div>
            <p><span>Celular:</span></p>
            <p><span>{`${user.phone}`}</span></p>
            </div>
        }
        {user.instagram &&
            <div>
            <p><span>Instagram:</span></p>
            <p><span>{`${user.instagram}`}</span></p>
            </div>
        }
        {user.occupation &&
            <div>
            <p><span>Ocupación:</span></p>
            <p><span>{`${user.occupation}`}</span></p>
            </div>
        }
        {(user.assigned_id && follower) &&
            <div>
            <p><span>Asignado a:</span></p>
            <p><span>{`${follower.name}`}</span></p>
            </div>
        }
        {user.eps &&
            <div>
            <p><span>EPS:</span></p>
            <p><span>{`${user.eps}`}</span></p>
            </div>
        }
        {(user.emergency_contact || user.emergency_phone) &&
            <div>
            <p><span>Contacto de emergencia:</span></p>
            <p><span>{`${user.emergency_contact}`}</span></p>
            <p><span>{`${user.emergency_phone}`}</span></p>
            </div>
        }
    </>
    );

};

export default UserBasicInformation;